import { Grid } from '@material-ui/core';
import { Content, Header, Page } from '@backstage/core-components';
import {
  HomePageRecentlyVisited,
  HomePageStarredEntities,
} from '@backstage/plugin-home';

export const homePage = (
  <Page themeId="home">
    <Header
      title="Developer Portal"
      pageTitleOverride="Home"
      subtitle="Everything you own, in one place"
    />
    <Content>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <HomePageStarredEntities />
        </Grid>
        <Grid item xs={12} md={6}>
          <HomePageRecentlyVisited />
        </Grid>
      </Grid>
    </Content>
  </Page>
);
